import React, { ChangeEvent } from 'react';
import { ServiceReminderTimingOffsetUnit } from 'shared/types/graphql';
import { ITime } from '.';
import { Flex, HStack } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Select, SelectOptionProps } from '@televet/kibble-ui/build/components/Select';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';
import { TimePicker } from '@televet/kibble-ui/build/components/TimePicker';
import { Icon } from '@televet/kibble-ui/build/components/Icon';

interface ReminderTimingRowProps {
  timingType: string;
  index: number;
  offset: number;
  offsetUnit: ServiceReminderTimingOffsetUnit;
  hourOfDay: number;
  minuteOfHour: number;
  handleChange: (index: number, name: string, value: string | number, time?: ITime) => void;
  handleDelete: (index: number) => void;
}

const ReminderTimingRow = ({
  timingType,
  index,
  offset,
  offsetUnit,
  hourOfDay,
  minuteOfHour,
  handleChange,
  handleDelete,
}: ReminderTimingRowProps): JSX.Element => {
  const date = new Date();
  date.setHours(hourOfDay, minuteOfHour);

  const handleFieldsChange = (name: string, value: string | number): void => {
    if (name === 'offset') {
      value = Number(value);
    }
    handleChange(index, name, value);
  };

  const handleDateChange = (date: Date): void => {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    handleChange(index, 'time', '', { hours, minutes });
  };

  return (
    <HStack spacing={2} alignSelf="stretch">
      <Flex>
        <TextInput
          type="number"
          value={String(offset)}
          maxW={16}
          onChange={(e: ChangeEvent<HTMLInputElement>): void => handleFieldsChange('offset', e.target.value)}
        />
      </Flex>
      <Flex>
        <Select
          value={offsetUnit}
          w="120px"
          listProps={{
            onSelect: (selectedItem: SelectOptionProps): void =>
              handleFieldsChange('offsetUnit', selectedItem?.value || ''),
          }}
          options={[
            {
              label: ServiceReminderTimingOffsetUnit.Days,
              value: ServiceReminderTimingOffsetUnit.Days,
            },
            {
              label: ServiceReminderTimingOffsetUnit.Weeks,
              value: ServiceReminderTimingOffsetUnit.Weeks,
            },
            {
              label: ServiceReminderTimingOffsetUnit.Months,
              value: ServiceReminderTimingOffsetUnit.Months,
            },
          ]}
        />
      </Flex>
      <Flex>
        <Select
          value={timingType}
          w="120px"
          listProps={{
            onSelect: (selectedItem: SelectOptionProps): void =>
              handleFieldsChange('timingType', selectedItem?.value || ''),
          }}
          options={[
            {
              label: 'Before',
              value: 'BeforeDue',
            },
            {
              label: 'After',
              value: 'PastDue',
            },
          ]}
        />
      </Flex>
      <Flex h={10}>
        <Text mt={2}>at</Text>
      </Flex>
      <Flex>
        <TimePicker
          initialTime={date}
          onTimeChange={(date: Date): void => handleDateChange(date)}
          inputProps={{ rightElement: <Icon name="chevronDown" size="sm" />, formControlStyle: { maxW: '120px' } }}
          placement="bottom"
        />
      </Flex>
      <Flex>
        <Button variant="ghostNeutral" iconName="trashcan" size="md" onClick={(): void => handleDelete(index)} />
      </Flex>
    </HStack>
  );
};

export default ReminderTimingRow;
